module.exports = __webpack_public_path__ + "assets/img/yzzx_anrukaixuan.afcf23e0.png";